import * as fromTypes from "../actions/types";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter, switchMap } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
import {
    onAddSiteInspectionChecklistSaveSuccess,
    onAddSiteInspectionChecklistSaveFailed
} from "../actions";
import { onSiteInspectionChecklistCreateRequest } from "features/health-and-safety/actions";

// This effect handles the form submission and dispatches the create request to the API
const addSiteInspectionChecklistFormSubmitEffect = (action$, state$) =>
    action$.pipe(
        ofType(fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_SUBMIT),
        filter(() => tokenExists()),
        filter(() => !!state$.value.organisations.currentOrganisation),
        filter(() => state$.value.queue.hasNetwork),
        switchMap(({ payload }) => {
            console.log("Site Inspection Checklist Form Submit Effect:", payload);
            
            // Dispatch the create request action to send the data to the API
            return of(onSiteInspectionChecklistCreateRequest(payload));
        })
    );

export default addSiteInspectionChecklistFormSubmitEffect; 